module.exports = __webpack_public_path__ + "img/1.0d38b056.jpg";